import React from "react";
import { connect } from "react-redux";
import { Input } from "../Input/index.js";
import language from "../../language/index.js";
import { Button } from "../Button/index.js";
import api from "../../utils/api/index.js";
import toastMessage from "../../utils/toastMessage.js";
import { fetchShippingInQueueData } from "../../utils/queries/request/shipping-queue.js";
import { getStorage } from "../../utils/storage.js";
import handleSearch from "../../utils/handleSearch.js";
import Table from "../Table/Table.js";
import ShippingInQueue from "../Requests/shipping/ShippingInQueue.js";
import { Modal } from "../Modal/index.js";

let copyData = [];

class ReceptionRequestBulk extends React.Component {
  state = {
    error: {},
    data: [],
    isDoneSearching: false,
    product: "",
    donationNumber: "",
    requestNo: "",
    shipmentNumber: "",
// eslint-disable-next-line no-dupe-keys
  };

  componentDidMount() {
    this.setState({
      shipmentNumber: this.props.shipmentNumber || "",
    });
  }

  getShipmentInfo = async () => {
    const { shipmentNumber } = this.state;

    this.setState({ isLoading: true });

    console.log({ shipmentNumber });

    const data = await fetchShippingInQueueData(this.props.defaultLanguage, {
      shipmentNumber,
    });

    this.setState({ isLoading: false });

    if ((data || []).length === 0)
      return toastMessage(
        "error",
        "Shipment number does not exist" + shipmentNumber,
      );

    this.setState({ data });

    copyData = data.slice(0);
  };

  renderHeaderTable = () => {
    const headers = [
      {
        title: "#",
        type: "numbering",
      },
      {
        title: language[this.props.defaultLanguage].donation_number,
        key: "donation.donationNumber",
      },
      {
        title: language[this.props.defaultLanguage].product,
        key: "product",
      },
      {
        title: language[this.props.defaultLanguage].stock,
        key: "to.name",
      },

      {
        title: language[this.props.defaultLanguage].status,
        key: "status",
        type: "status",
      },
      //  {
      //     title: "",
      //     key: "multiple-actions",
      //     actions: [
      //       {
      //         icon: icons.delete,
      //         title: language[this.props.defaultLanguage].delete,
      //         className: "btn-danger",
      //         onPress: (item) =>{
      //           if(window.confirm(language[this.props.defaultLanguage].delete)){
      //             this.handleRemove(item)
      //           }
      //         }

      //       }
      //     ],
      //   },
    ];

    return headers;
  };

  validateForm() {
    let { error, shipmentNumber } = this.state;

    if (shipmentNumber === "") {
      error.shipmentNumber =
        language[this.props.defaultLanguage].shipment_number_required;
    }

    this.setState({ error });
  }

  onSubmit = async () => {
    await this.validateForm();

    try {
      if (Object.keys(this.state.error).length > 0) return;

      const { shipmentNumber, data } = this.state;
      const user = await getStorage();

      this.setState({
        isSubmitting: true,
      });

      if (data.length === 0) {
        this.setState({
          isSubmitting: false,
        });

        toastMessage("error", "Shipment number does not exist");
        return;
      }

      console.log({ userStock: user.stock, to: data[0].to });

      if (user.stock && data[0].to?._id !== user.stock) {
        this.setState({
          isSubmitting: false,
        });

        toastMessage(
          "error",
          language[this.props.defaultLanguage].not_allowed_t_receive_shipment,
        );
        return;
      }

      let method = "POST",
        requestBody = {
          inventory: data[0].inventory._id,
          shipmentNumber,
          to: data[0].to?._id,
          from: data[0].from?._id,
          type: "bulk",
        };

      const options = {
        method,
        url: `${process.env.REACT_APP_BBMS_BASE_API}/shipping-queue/reception`,
        data: requestBody,
      };

      const response = await api(options);

      await this.getShipmentInfo();
      this.props.getData && this.props.getData();

      this.setState({
        isSubmitting: false,
        shipmentNumber: "",
      });

      toastMessage(
        "success",
        response?.data?.message ||
          language[this.props.defaultLanguage].add_data_success,
      );
    } catch (error) {
      console.log(error);
      this.setState({ isSubmitting: false });
      toastMessage("error", error);
    }
  };

  onChangeText = async (field, e) => {
    let { error } = this.state;
    let inputValue = e && e?.target ? e?.target?.value : e;

    delete error[field];

    this.setState({
      [field]: inputValue,
      isDoneSearching: false,
    });
  };

  handleShowModal = (modal) => {
    this.setState({
      [modal]: true,
    });
  };

  handleCloseModal = (modal) => {
    this.setState({
      [modal]: false,
    });
  };

  render() {
    return (
      <>
        <Input
          placeholder={
            language[this.props.defaultLanguage].shipment_number_placeholder
          }
          label={language[this.props.defaultLanguage].shipment_number}
          value={this.state.shipmentNumber}
          onChange={(e) => this.onChangeText("shipmentNumber", e)}
          error={this.state.error.shipmentNumber}
        />
        {this.props.handleCloseModal && (
          <Button
            className="btn-default"
            text={language[this.props.defaultLanguage].cancel}
            onPress={this.props.handleCloseModal}
          />
        )}
        {this.state.data.length === 0 && (
          <Button
            text={language[this.props.defaultLanguage].search}
            isSubmitting={this.state.isLoading}
            onPress={this.getShipmentInfo.bind(this)}
          />
        )}
        {this.state.data.length > 0 && (
          <Table
            headers={this.renderHeaderTable()}
            data={this.state.data}
            showAdd={
              this.state.data.filter((item) => item.status !== "received")
                .length > 0
            }
            addButtonText="Confirm Reception of Selected Products"
            handleAddPressed={this.onSubmit.bind(this)}
            addButtonLoading={this.state.isSubmitting}
            isSearch
            search_text={this.state.search_text}
            handleSeach={(e) =>
              handleSearch(this, {
                copyData,
                value: this.state.search_text,
              })
            }
            filters={[
              {
                canAccess:
                  this.state.data.filter((item) => item.status === "received")
                    .length > 0,
                title: language[this.props.defaultLanguage].print,
                icon: "print",
                onPress: this.handleShowModal.bind(
                  this,
                  "showPrint",
                  language[this.props.defaultLanguage].print,
                ),
              },
            ]}
          />
        )}

        <Modal
          handleClose={this.handleCloseModal.bind(this, "showPrint")}
          show={this.state.showPrint}
          title={this.props.shipmentNumber}
          showHeaderBottomBorder={false}
          size="lg"
        >
          {this.state.data.length > 0 && (
            <>
              <ShippingInQueue
                handleCloseModal={() => {
                  this.handleCloseModal("showPrint");
                }}
                shipmentNumber={this.props.shipmentNumber}
                from={this.state.data[0].from}
                to={this.state.data[0].to}
                status={this.state.data[0].status || "pending"}
                createdAt={this.state.data[0].createdAt}
                recepientName={this.state.data[0].recepientName}
              />
            </>
          )}
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(ReceptionRequestBulk);
